import type { NotificationItem } from "./topbarTypes";

/** Above this, the bell's badge shows "9+" instead of the exact number. */
export const MAX_BADGE_COUNT = 9;

export function unreadCount(items: NotificationItem[]): number {
  return items.filter((item) => item.unread).length;
}

export function unreadBadge(unread: number): string | number {
  return unread > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : unread;
}

/** The bell's accessible name, which tells how many are unread. */
export function notificationsLabel(unread: number): string {
  return unread > 0 ? `Notifications, ${unread} unread` : "Notifications";
}
